import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DashboardFilterService {
  filter = new BehaviorSubject<any>(null);
  openStatus = new BehaviorSubject<any>(false);
  // có thể subcribe theo dõi thay đổi value của biến này thay cho messageSource

  constructor() { }

  // method này để change source message 
  setData(filter) {
    this.filter.next(filter);
  }
  getData() {
    return this.filter.asObservable();;
  }

  openLoader(status) {
    this.openStatus.next(status);
  }

  getOpenLoaderStatus() {
    return this.openStatus.asObservable();
  }

}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard-filter/dashboard-filter.service.ts